import './ButtonDebug.css';
import { useBotStateContext } from '../../../contexts/BotContext';
import useBlockCamera from '../../../hook/block/useBlockCamera';
import { useState } from 'react';

// Component to move camera on the block's who have some errors on them (path's missing or bad configuration)
function ButtonDebug() {

    const { errors } = useBotStateContext();
    const { jumpToPosition } = useBlockCamera();
    const [index, setIndex] = useState(0);
    const errorsArray = Object.values(errors);

    const followBlockError = () => {
        const block = errorsArray[index];
        setIndex(errorsArray.length == index + 1 ? 0 : index + 1);
        jumpToPosition(block.x, block.y);
    }
    return <div className={errorsArray.length ? 'debug red' : 'debug'} onClick={followBlockError}>{errorsArray.length}</div>
}

export default ButtonDebug